import factory from './icon';
import HidePassword from './glyphs/hide-password.svg';
import ShowPassord from './glyphs/show-password.svg';

export const hide = factory(HidePassword);

export const show = factory(ShowPassord);

